// @flow
import * as React from 'react'
import ReactCardFlip from 'react-card-flip'
import * as isTouch from 'has-touch'
import { detect } from 'detect-browser'

import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/flag.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/button.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/divider.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/label.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/table.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import './style.scss'

type Props = {
  data: [],
  columnsDesktop: string,
  columnsMobile: string
}

type State = {
  isOpen: boolean,
  isFlipped: false
}

const browser = detect()
export class SingleMascot extends React.Component<Props, State> {
  state = {
    isOpen: false,
    isFlipped: false
  }

  handleClick(e) {
    e.preventDefault()
    if (!isTouch) {
      return
    }
    this.trackNavClicks(e)
    this.setState({
      isFlipped: !this.state.isFlipped
    })
  }

  componentDidMount() {
    this.setState({
      browser: browser.name
    })
  }

  handleMouseEnter(e) {
    if (isTouch) {
      return
    }
    if (this.state.browser === 'ie' && this.state.isFlipped >= 0) {
      // console.log('Browser: ' + this.state.browser)
    }
    this.trackNavClicks(e)
    e.preventDefault()
    this.setState({
      isFlipped: true
    })
  }

  handleMouseLeave(e) {
    if (isTouch) {
      return
    }
    e.preventDefault()
    this.setState({
      isFlipped: false
    })
  }

  trackNavClicks(e) {
    let clickedText = this.props.data.title
    let device = isTouch ? 'tap' : 'click'
    window.dataLayer = window.dataLayer || []
    if (device === 'tap') {
      window.dataLayer.push({
        event: 'Interactions',
        event_action: device,
        event_label: 'id:' + (this.props.id + 1) + ' city:' + clickedText
      })
    }
  }

  constructor(props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
    this.handleMouseEnter = this.handleMouseEnter.bind(this)
    this.handleMouseLeave = this.handleMouseLeave.bind(this)
    this.trackNavClicks = this.trackNavClicks.bind(this)
  }

  render() {
    // console.log("BROWSER", browser)

    return (
      <div
        className={`${
          window.innerWidth < 1150
            ? this.props.columnsMobile
            : this.props.columnsDesktop
        } wide doubling column centered mascot-outer-wrapper`}
      >
        <div
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
          onClick={this.handleClick}
          className={`mascot-container`}
        >
          <div className='titleWrapper'>
            <h4
              style={{
                margin: '0',
                lineHeight: '1.25em'
              }}
            >
              {this.props.data.year}
            </h4>

            <div className='flip-button-container mobile only'>
              <div
                className={`ui icon inverted small button ${
                  this.state.isFlipped ? 'active' : ''
                }`}
              >
                <i
                  className={`icon ${
                    this.state.isFlipped ? 'remove' : 'repeat'
                  }`}
                />
              </div>
            </div>
          </div>

          {this.state.isFlipped && this.state.browser === 'ie' && (
            <p
              style={{ position: 'relative', paddingTop: '15px' }}
              className={`${this.props.data.category} mascot-text`}
            >
              <strong>{this.props.data.title} </strong>
              <br />
              <i>{this.props.data.names}</i>
              <br /> {this.props.data.textLong}
            </p>
          )}
          <ReactCardFlip
            isFlipped={this.state.isFlipped}
            style={{
              backfaceVisibility:
                this.state.isFlipped && this.state.browser === 'ie'
                  ? 'visible'
                  : 'hidden',
              transform:
                this.state.isFlipped && this.state.browser === 'ie'
                  ? 'rotateY(0deg)'
                  : 'rotateY(180deg)'
            }}
          >
            <div key='front' className='mascot-inner-wrapper'>
              <img
                src={require('./imgs/' + this.props.data.image)}
                alt={this.props.data.city}
                className='ui image fluid centered'
                style={{
                  display:
                    this.state.isFlipped && this.state.browser === 'ie'
                      ? 'none'
                      : 'block'
                }}
              />
            </div>

            <div
              key='back'
              className='mascot-inner-wrapper back-face'
              style={{
                backfaceVisibility:
                  this.state.isFlipped && this.state.browser === 'ie'
                    ? 'visible'
                    : 'hidden',
                transform:
                  this.state.isFlipped && this.state.browser === 'ie'
                    ? 'rotateY(0deg)'
                    : '',
                position: this.state.isFlipped
                  ? 'absolute !important'
                  : 'relative !important',
                display:
                  this.state.isFlipped && this.state.browser === 'ie'
                    ? 'none'
                    : 'block'
              }}
            >
              <p className={`${this.props.data.category} mascot-text`}>
                <strong>{this.props.data.title} </strong>
                <br />
                <i>{this.props.data.names}</i>
                <br />
                {this.props.data.textLong}
              </p>
            </div>
          </ReactCardFlip>
        </div>
      </div>
    )
  }
}

export default SingleMascot
